module.exports = __webpack_public_path__ + "img/chaxun.994b1d9e.png";